var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640-200q-34 0-64.5-7.5T516-229q57-50 90.5-114.5T640-480q0-72-33.5-136.5T516-731q29-14 59.5-21.5T640-760q117 0 198.5 81.5T920-480q0 117-81.5 198.5T640-200Zm-160-50q-54-38-87-98t-33-132q0-72 33-132t87-98q55 38 87.5 98T600-480q0 72-32.5 132T480-250Zm-160 50q-117 0-198.5-81.5T40-480q0-117 81.5-198.5T320-760q34 0 65 7.5t59 21.5q-57 50-90.5 114.5T320-480q0 77 33 142t90 110q-28 14-59 21t-64 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.610d1cecb64b0dccf811a3969e9fbe08.svg";
export { ForwardRef as ReactComponent };